module.exports = __webpack_public_path__ + "304e22ac35afb89ff4759abe7774ff3e.svg";